import { useEffect, useState } from 'react'
import * as React from 'react'
import styled from '@emotion/styled'
import { IoArrowDown } from 'react-icons/io5'
import { fontFamilies } from '@configs/styles/config'

interface AccordionProps {
  title: string
  content: React.ReactNode // Allow any content type
  openItem?: string
  setOpenItem: React.Dispatch<React.SetStateAction<string>>
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  content,
  openItem = '',
  setOpenItem,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setIsOpen(openItem === title)
  }, [openItem, title])

  const handleOpen = () => {
    setOpenItem((prev) => (prev === title ? '' : title))
  }

  return (
    <AccordionContainer>
      <AccordionTitle isOpen={isOpen} onClick={handleOpen}>
        {title}
        <AccordionIcon isOpen={isOpen}>
          {isOpen ? <IoArrowDown /> : <IoArrowDown />}
          {/* Simple icon for open/close state */}
        </AccordionIcon>
      </AccordionTitle>
      <AccordionContent
        isOpen={isOpen}
        dangerouslySetInnerHTML={{ __html: content }}
      ></AccordionContent>
    </AccordionContainer>
  )
}

const AccordionContainer = styled.div`
  max-width: 1000px;
  border-radius: 30px;
  padding: 60px 72px 24px 72px;
  background-color: #7181ff80;
  background: linear-gradient(98.85deg, #c4cbff 7.48%, #dbdfff 100.01%);
  @media screen and (max-width: 768px) {
    padding: 40px 1.5rem 8px 1.5rem;
  }
`

const AccordionTitle = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: ${fontFamilies.medium};
  letter-spacing: 0.05em;
  text-align: left;
  border-bottom: ${(props) =>
    props.isOpen ? '1px solid #1A1E3D7A' : '1px solid rgba(0,0,0,0)'};
  /* transition: all 0.17s ease-in-out; */
  padding-bottom: 17px;
  font-size: 26px;
  line-height: 36px;
  @media screen and (max-width: 1024px) {
    font-size: 24px;
    line-height: 33px;
  }
  @media screen and (max-width: 596px) {
    font-size: 16px;
    line-height: 18px;
  }
`

const AccordionIcon = styled.span<{ isOpen: boolean }>`
  transition: transform 0.2s ease-in-out;
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'rotate(0)')};
`

const AccordionContent = styled.div<{ isOpen: boolean }>`
  overflow: hidden;
  max-height: ${(props) => (props.isOpen ? '1000px' : '0')};
  /* transition: max-height 0.2s; */
  margin-top: 1rem;
  padding-bottom: ${(props) => (props.isOpen ? '1rem' : '0')};
  font-family: ${fontFamilies.regular};
  font-size: 16px;
  line-height: 19px;
  text-align: left;
  @media screen and (min-width: 1356px) {
    font-size: 17px;
    line-height: 24px;
  }
  @media screen and (min-width: 1656px) {
    font-size: 18px;
    line-height: 26px;
  }
`

export default Accordion
